define([
	"dojo/_base/declare",
	"csi/config",
	"csi/form/Widget",
	"csi/reflection",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Search"
], function(declare,config,Widget,reflection,csiStore,Names,xml,Search) {

	return declare(Widget, {

		FIELD_MERCH_PRODUCT_SUBTYPE: "MerchProductSubtype",
		FIELD_TEMPLATE: "Template",

		getFieldStore: function(/*Field*/field, /*String*/value) {
			if (field.getControlName() == this.FIELD_MERCH_PRODUCT_SUBTYPE) {
				return config.getSubtypeStore("MerchProduct");
			} else if (field.getControlName() == this.FIELD_TEMPLATE) {
				var merchProductType = reflection.getObject(this.defView.getFieldValue(this.FIELD_MERCH_PRODUCT_SUBTYPE));
				if (merchProductType) {
					var search = new Search();
					var q = search.getQuery();

					q.Attr("Active", xml.OP_EQUALS, true);
					search.setLimitAttribute(merchProductType.Settings, "StylePushTemplates");

					return new Names({
						data: [csiStore.nameObject("")],
						request: search.getRequest()
					});
				}
			}
			return this.inherited(arguments);
		}

	});
});